export default "__VITE_ASSET__BDhjSa9O__"